import specialDeductionsApi from '../../../api/specialDeductionsApi'
import {
  PERSONAL_DUTIES,
  CERTACILE_TYPE,
  PERSONAL_EDU,
  WORK_TYPE,
  YESORNO_TYPE,
  AUTHENTICATION_STATUS,
  SUBMISSION_STATUS
} from '../../../config/personal-income-tax'
import UserPersistence from '../../../persistence/UserPersistence'
import DateUtils from "../../../libs/utils/DateUtils";
import NumberUtils from "../../../libs/utils/NumberUtils";
import {MSG_MODES, MSG_TYPES, setMessage} from "../../../libs/message";

export const moduleId = "special-additional-deductions";

export const state = {
  isDetail: false,
  specialDialog: false,
  specialAddDialog: false,
  currentPage: 1,  //当前要查询的页码
  pageSize: 10,  //每页显示记录数量
  totalPage: 0,
  tableData: [],
  SpouseInformation: null,//配偶信息
  SpecialChildEdu: [],//子女
  SpecialLoanedu: [],//继续教育
  SpecialLoanedu1: [],
  SpecialLoan: null,//住房贷款
  HousingInformation: null,//住房信息
  ProvidentFund: null,//公积金贷款
  CommercialLoan: null,//商业贷款
  SpecialInfoHouse: [],//住房租金
  SpecialElderly: [],//赡养老人
  CareChildrenUnde: [],//3岁以下婴幼儿照护
  elderlyFrom: null,//
  beSupportedData: [],//被赡养
  jointSupport: [],//共同赡养
  specialTitleDetail: {
    specialDeductionElderlyDto: {}
  },
  params: {
    sourceCode: null, //	登录唯一标识
    abId: null, //账套id（所属机构）
    operator: null,
    year: null, //所属年度
    month: null, ////所属月份
  },
  form: {
    employeeName: "",
    employeeNumber: "",
    employeeStatus: "",
    entryDateEnd: "",
    entryDateStart: "",
    entryType: "",
    idNumber: "",
    isAphrodite: "",
    isDisability: "",
    isLonesome: "",
    quitDateEnd: "",
    quitDateStart: "",
    sendStatus: "",
    sourceId: 1,
    taxNumber: "",
    updateDateEnd: "",
    updateDateStart: 2,
    page: 1,
    size: 10,
  },
};

export const actions = {
  initView({state, commit, dispatch}) {
    dispatch('GetSpecialTitle');
  },
  onCreate({state, commit, dispatch}, {to, from}) {
    // dispatch('GetPersonalInfo');
    dispatch('initView');
  },
  // getSpecialTitleDetail
  async getSpecialTitleDetail({state, commit, dispatch}, params) {
    let res = await specialDeductionsApi.getSpecialTitleDetail(params)
    if (res.code === 0) {
      commit('setSpecialTitleDetail', res.data)
    }
  },
  // saveSpecialTitle
  // async saveSpecialTitle ({state, commit, dispatch}, params) {
  //   console.log(params);
  //
  // },
  //首页列表
  async GetSpecialTitle({state, commit, dispatch}) {
    let query = {
      ...state.form,
      ...state.params,
      page: state.currentPage,
      size: state.pageSize,
    }
    let res = await specialDeductionsApi.GetSpecialTitle(query)
    if (res.code === 0) {
      let data = res.data.data.data
      data.forEach(item => {
        item.updateDate = DateUtils.format(item.updateDate, "yyyy-MM-dd")
      })
      commit('setTableData', data)
      commit('setTotalPage', res.data.data.size);
    }
  },
  //删除

  async DelSpecialTitle({state, commit, dispatch}, params) {
    let query = {
      ids: params,
      ...state.params
    }
    let res = await specialDeductionsApi.DelSpecialTitle(params)
    if (!res.code) {
      dispatch('GetSpecialTitle')
      setMessage({
        type: "success",
        message: '删除成功',
      });
    } else {
      setMessage({
        type: "error",
        message: res.msg,
      });
    }
  },
  //子女
  async GetSpecialChildEdu({state, commit, dispatch}) {
    let query = {
      ...state.form,

      idNumber: state.SpouseInformation.idNumber,
      ...state.params
    }
    let res = await specialDeductionsApi.GetSpecialChildEdu(query)
    if (res.code === 0) {
      let data = res.data.data.data
      data.forEach(item => {
        item.childrenBirthday = DateUtils.format(item.childrenBirthday, "yyyy-MM-dd"),
          item.currentEduEndTime = DateUtils.format(item.currentEduEndTime, "yyyy-MM"),
          item.currentEduStartTime = DateUtils.format(item.currentEduStartTime, "yyyy-MM"),
          item.updateDate = DateUtils.format(item.updateDate, "yyyy-MM-dd"),
          item.deductionProportion = NumberUtils.formatDecimalsToPercent(item.deductionProportion) + '%',
          item.source = '扣缴义务人',
          item.status = '验证通过',
          item.deductionStartTime = DateUtils.format(item.deductionStartTime, "yyyy-MM-dd"),
          item.deductionEndTime = DateUtils.format(item.deductionEndTime, "yyyy-MM-dd")

      })
      commit('setSpecialChildEdu', data)
    }
  },
  //继续教育
  async GetSpecialLoanedu({state, commit, dispatch}) {
    let query = {
      ...state.form,
      idNumber: state.SpouseInformation.idNumber,
      ...state.params
    }
    let res = await specialDeductionsApi.GetSpecialLoanedu(query)
    if (res.code === 0) {
      let data = res.data
      data.dataDegree.data.forEach(item => {
        item.createDate = DateUtils.format(item.createDate, "yyyy-MM"),
          item.currentStartEduTime = DateUtils.format(item.currentStartEduTime, "yyyy-MM"),
          item.currentEndEduTime = DateUtils.format(item.currentEndEduTime, "yyyy-MM"),
          item.updateDate = DateUtils.format(item.updateDate, "yyyy-MM-dd")
        item.source = "扣缴义务人",
          item.deductionStartTime = DateUtils.format(item.deductionStartTime, "yyyy-MM-dd"),
          item.deductionEndTime = DateUtils.format(item.deductionEndTime, "yyyy-MM-dd")
      })
      data.dataOccupation.data.forEach(item => {
        item.createDate = DateUtils.format(item.createDate, "yyyy-MM"),
          item.currentEndEduTime = DateUtils.format(item.currentEndEduTime, "yyyy-MM"),
          item.updateDate = DateUtils.format(item.updateDate, "yyyy-MM-dd")
        item.source = "扣缴义务人",
          item.deductionStartTime = DateUtils.format(item.deductionStartTime, "yyyy-MM-dd"),
          item.deductionEndTime = DateUtils.format(item.deductionEndTime, "yyyy-MM-dd")
      })
      commit('setSpecialLoanedu', data)
      // commit('setSpecialLoanedu1', res.data.dataOccupation.data)
    }
  },
  //住房贷款
  async GetSpecialLoan({state, commit, dispatch}) {
    // console.log(query)
    let query = {
      ...state.form,

      idNumber: state.SpouseInformation.idNumber,
      ...state.params

    }
    let res = await specialDeductionsApi.GetSpecialLoan(query)
    if (res.code === 0) {
      let data = res.data
      let obj = Object.assign({}, {
        ...res.data.data.data,
        isFirstLoan: data.data.data && data.data.data.isFirstLoan + '',
        isOneself: data.data.data && data.data.data.isOneself + ''

      })
      commit('setHousingInformation', obj)
      if (data.data.dataList && data.data.dataList.length > 0) {
        data.data.dataList.forEach(item => {
          if (item.loanType == "2") {
            commit("setCommercialLoan", item)
          } else if (item.loanType == "1") {
            commit("setProvidentFund", item)
          }
        })
      }
    }
  },
  //住房租金
  async GetSpecialInfoHouse({state, commit, dispatch}) {
    // console.log(query)
    let query = {
      ...state.form,
      ...state.params,
      idNumber: state.SpouseInformation.idNumber
    }
    let res = await specialDeductionsApi.GetSpecialInfoHouse(query)
    if (res.code === 0) {
      let data = res.data.data.data
      if (data.length > 0) {
        data.forEach(item => {
          item.houseStartTime = DateUtils.format(item.houseStartTime, "yyyy-MM"),
            item.houseEndTime = DateUtils.format(item.houseEndTime, "yyyy-MM"),
            item.updateDate = DateUtils.format(item.updateDate, "yyyy-MM-dd"),
            item.source = '扣缴义务人',
            item.deductionStartTime = DateUtils.format(item.deductionStartTime, "yyyy-MM-dd"),
            item.deductionEndTime = DateUtils.format(item.deductionEndTime, "yyyy-MM-dd")
        })
        commit('setSpecialInfoHouse', data)
      }
    }
  },
  //赡养老人
  async GetSpecialElderly({state, commit, dispatch}) {
    // console.log(query)
    let query = {
      ...state.form,
      idNumber: state.SpouseInformation.idNumber,
      ...state.params
    }
    let res = await specialDeductionsApi.GetSpecialElderly(query)
    if (res.code == 0) {
      let data = res.data.data
      let obj = Object.assign({}, {
        ...data.data,
        isOnlyChild: data.data && data.data.isOnlyChild + ''

      })
      commit('setElderlyFrom', obj)
      if (data.dataDependant.length > 0) {
        data.dataDependant.forEach(item => {
          item.updateDate = DateUtils.format(item.updateDate, "yyyy-MM-dd"),
            item.deductionStartTime = DateUtils.format(item.deductionStartTime, "yyyy-MM-dd"),
            item.deductionEndTime = DateUtils.format(item.deductionEndTime, "yyyy-MM-dd")
        })
        commit('setBeSupportedData', data.dataDependant)
      }
      if (data.dataJoint.length > 0) {
        commit('setJointSupport', data.dataJoint)
      }
    }
  },
  //3岁以下婴幼儿照护
  async GetSpecialInfant({state, commit, dispatch}) {
    let query = {
      ...state.form,
      idNumber: state.SpouseInformation.idNumber,
      ...state.params
    }
    let res = await specialDeductionsApi.GetSpecialInfant(query)
    if (res.code === 0) {
      let data = res.data.data.data
      data.forEach(item => {
        item.deductionProportion = NumberUtils.formatDecimalsToPercent(item.deductionProportion) + '%',
          item.source = '扣缴义务人',
          item.status = '验证通过'
      })
      commit('setCareChildrenUnde', data)
    }
  },
  //报送
  async SendSpecialInfo({state, commit, dispatch}, params) {
    // console.log(query)
    let query = {
      ids: params,
      ...state.params
    }
    if (!params.n) {
      setMessage({
        type: "error",
        message: '已报送无需报送',
      });
    } else {
      let res = await specialDeductionsApi.DendSpecialTitle(params.arr)
      if (!res.code) {
        dispatch('GetSpecialTitle')
        if (!params.m) {
          setMessage({
            type: "success",
            message: '报送成功',
          });
          // } else if (!params.n) {
          //     setMessage({
          //         type: "error",
          //         message: '已报送无需报送',
          //     });
        } else {
          setMessage({
            type: "success",
            message: `报送成功,其中${params.m}条已报送无需报送`,
          });
        }
      } else {
        setMessage({
          type: "error",
          message: res.msg,
        });
      }
    }
  },
};

export const mutations = {
  setIsDetail(state, flag) {
    state.isDetail = flag
  },
  setSpecialTitleDetail(state, detail) {
    state.specialTitleDetail = detail
  },
  setspecialDialog(state, falg) {
    state.specialDialog = falg
  },
  setspecialAddDialog(state, falg) {
    state.specialAddDialog = falg
  },
  //关闭弹窗清楚数据
  clearTable(state, data) {
    state.SpouseInformation = null,//配偶信息
      state.SpecialChildEdu = [],//子女
      state.SpecialLoanedu = [],//继续教育
      state.SpecialLoanedu1 = [],
      state.SpecialLoan = null,//住房贷款
      state.HousingInformation = null,//住房信息
      state.ProvidentFund = null,//公积金贷款
      state.CommercialLoan = null,//商业贷款
      state.SpecialInfoHouse = [],//住房租金
      state.SpecialElderly = [],//赡养老人
      state.elderlyFrom = null,//
      state.beSupportedData = [],//被赡养
      state.jointSupport = []//共同赡养
    state.CareChildrenUnde = [] //3岁以下婴幼儿照护
  },
  //配偶

  setSpouseInformation(state, data) {
    state.SpouseInformation = data
    // state.SpouseInformation = {
    //   ...data,
    //   certificateType: CERTACILE_TYPE.filter(item => {
    //     return data.certificateType == item.id
    //   })[0].name,
    //   spouseCertificateType: CERTACILE_TYPE.filter(item => {
    //     return data.spouseCertificateType == item.id
    //   })[0].name
    // }
    //    state.SpouseInformation.certificateType = data.certificateType==1?'居民身份证':''
  },
  setTableData(state, data) {
    state.tableData = data
  },
  //子女
  setSpecialChildEdu(state, data) {
    state.SpecialChildEdu = data
  },
  //继续教育
  setSpecialLoanedu(state, data) {
    state.SpecialLoanedu = data.dataDegree.data
    state.SpecialLoanedu1 = data.dataOccupation.data
  },
  //住房贷款
  setHousingInformation(state, data) {
    state.HousingInformation = data
  },
  //商贷
  setCommercialLoan(state, data) {
    state.CommercialLoan = data
  },
  //公积金
  setProvidentFund(state, data) {
    state.ProvidentFund = data
  },
  //住房信息
  setSpecialInfoHouse(state, data) {
    state.SpecialInfoHouse = data
  },
  setElderlyFrom(state, data) {
    state.elderlyFrom = data
  },
  //被抚养
  setBeSupportedData(state, data) {
    state.beSupportedData = data
  },
  //共同抚养
  setJointSupport(state, data) {
    state.jointSupport = data
  },
  //共同抚养
  setCareChildrenUnde(state, data) {
    state.CareChildrenUnde = data
  },
  //设置搜索条件
  setSearchForm(state, param) {
    state.form = Object.assign(state.form, param);
  },
  //总条数
  setTotalPage(state, data) {
    state.totalPage = data
  },
  //当前页码设置
  setCurrentPage(state, data) {
    state.currentPage = data;
  },
  //当前页显示条数
  setPageSize(state, data) {
    state.pageSize = data;
  },
  setSpecionParams(state, params) {
    state.params = Object.assign({
      sourceCode: params.sourceCode,
      abId: params.abId,
      operator: params.operator,
      year: params.year,
      month: params.month
    })
  },
};
// export const getters = {
//     tableDataTableGetter(state) {
//         console.log(state.tableData)
//         if (state.tableData.length > 0) {
//             return state.tableData.map((item) => {
//                 return {
//                     ...item,
//                     // sex: item.sex ? "女" : "男",
//                     // verificationStatus: item.verificationStatus == 1 ? "待验证" : "已验证",
//                     // isDisability: item.isDisability ? "是" : '否',
//                     // isAphrodite: item.isAphrodite ? "是" : '否',
//                     // isLonesome: item.isLonesome ? "是" : '否',
//                     // entryType: item.entryType == 1 ? "雇员" : '其他',
//                     // country: item.country && "中国"

//                 }
//             })
//         } else {
//             return [];
//         }
//     }
// }



// WEBPACK FOOTER //
// ./src/store/modules/special-additional-deductions/index.js